import { colors } from "../../../../../common/styles";

export default {
    hideFont: {
        fontSize: 0,
        "& svg": {
            color: "inherit"
        },
        "& .MuiBadge-root .MuiBadge-badge": {
            margin: "6px 0"
        }
    },

    pillMatchButton: {
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "primary.main",
        borderRadius: "16px",
        padding: "4px 8px",
        cursor: "pointer",
        bgcolor: "primary.lighter"
    },
    pillError: {
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "error.main",
        borderRadius: "16px",
        padding: "4px 8px",
        color: "error.main"
    },
    pillMatched: {
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "success.main",
        borderRadius: "16px",
        padding: "4px 8px",
        color: "success.main"
    },
    pillResolve: {
        display: "flex",
        alignItems: "center",
        borderRadius: "16px",
        border: "1px solid",
        padding: "4px 8px",
        cursor: "pointer",
        color: "info.main"
    },
    pillResolved: {
        display: "flex",
        borderColor: "success.main",
        alignItems: "center",
        border: "1px solid",
        borderRadius: "16px",
        padding: "4px 8px"
    },

    primaryButton: {
        backgroundColor: colors.blue,
        color: colors.white,
        borderRadius: 32,
        px: 2,
        py: 1,
        ":hover": {
            backgroundColor: colors.blue,
            color: colors.white
        }
    },
    toolBarButtons: { m: 1, borderRadius: 16 },
    containerStyle: {
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        cursor: "pointer"
    }
};

export const getTextStyle = (isActive, theme) => ({
    margin: 2,
    p: 2,
    color: isActive ? colors.blue : "inherit",
    borderBottom: isActive ? `1px solid ${colors.blue}` : "none",
    marginRight: isActive ? "8px" : "0" // Add margin to space items if necessary
});
